import { render } from "./ModuleData.vue?vue&type=template&id=24b9e3d9"
import script from "./ModuleData.vue?vue&type=script&lang=js"
export * from "./ModuleData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__